import { render, staticRenderFns } from "./CpOrderList.vue?vue&type=template&id=699fd995"
import script from "./CpOrderList.vue?vue&type=script&lang=js"
export * from "./CpOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports